import React from 'react'

import { AdminDrawer } from '../Admins/AdminDrawer'
import { NavigatorsDrawer } from '../Navigators/NavigatorsDrawer'

interface WebPortalUsersDrawerProps {
  isAdmin: boolean
  open: boolean
  onCloseDrawer: () => void
  selectedId?: string
}

export const WebPortalUsersDrawer: React.FC<WebPortalUsersDrawerProps> = ({
  isAdmin,
  open,
  onCloseDrawer,
  selectedId,
}) => {
  return isAdmin ? (
    <AdminDrawer
      open={open}
      onCloseDrawer={onCloseDrawer}
      selectedId={selectedId}
    />
  ) : (
    <NavigatorsDrawer
      open={open}
      onCloseDrawer={onCloseDrawer}
      selectedId={selectedId}
    />
  )
}
